import React from 'react';

import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';

export interface TipoUsuarioProps {
    idTipoUsuario: number;
    dsTipoUsuario: string;
    tipoUsuarioEnum: string;
}

type TipoUsuarioAutoCompleteProps = Pick<
    CissAutoCompleteProps,
    'value' | 'error' | 'multiple' | 'disabled' | 'sx' | 'onChange' | 'name' | 'label' | 'disableClearable'
>;

export function TipoUsuarioAutoComplete({
    sx,
    name,
    value,
    error,
    multiple = false,
    disabled = false,
    disableClearable = true,
    onChange = () => {},
    label = 'Tipo do usuário',
}: TipoUsuarioAutoCompleteProps) {
    return (
        <CissAutoComplete
            sx={sx}
            name={name}
            error={error}
            value={value}
            label={label}
            onChange={onChange}
            multiple={multiple}
            disabled={disabled}
            disableClearable={disableClearable}
            optionStringTemplate="{dsTipoUsuario}"
            selectedStringTemplate="{dsTipoUsuario}"
            isOptionEqualToValue={(option: TipoUsuarioProps, value: TipoUsuarioProps) => option.idTipoUsuario === value.idTipoUsuario}
            requestOptions={{
                url: '/gestao/tipousuario',
                columns: 'idTipoUsuario,dsTipoUsuario',
                nested: true,
            }}
        />
    );
}
